import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
     .module('oddCampaignModule')
     .controller('oddCampaignSummaryController', Controller);

    Controller.$inject = ['$scope', 'oddCampaignService', 'exportService'];

    function Controller($scope, oddCampaignService, exportService) {

        // Show Summary?
        $scope.showSummary = function () {
            return $scope.boxModel.HasResponses;
        }

        // Show Campaign Export?
        $scope.showCampaignExport = function () {
            if (!$scope.boxModel.ODDCampaignID) return false;
            if ($scope.boxModel._stateLoading) return false;
            if (!$scope.boxModel.ProgressState) return false;
            if ($scope.boxModel.ProgressState.Value !== 'Completed') return false;
            if (!$scope.boxModel.ProgressStatus) return false;

            return $scope.boxModel.ProgressStatus.Value === 'Draft' ||
                    $scope.boxModel.ProgressStatus.Value === 'Published';
        };

        $scope.pollExport = function () {
          exportService.pollExport($scope.getCampaignExportUrl(), {});
        };

        $scope.getCampaignExportUrl = function () {
            var buId = $scope.boxModel.ODDBusinessUnitID;
            var extPartyId = $scope.boxModel.ODDExternalPartyID;
            var campId = $scope.boxModel.ODDCampaignID;

            var url = environment.apiUrl + '/ReportPilot/API/ODD/BusinessUnit/' + buId +
                      '/ExternalParty/' + extPartyId +
                      '/Campaign/' + campId +
                      '/Export/QuestionAnswer/To/PDF';

            return url;
        };
    }

})();
